import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { UnitTypes } from '@modules/teeth-diagram/models/unit-type.enum';
import { IntuitiveIndication, toUnitType, toUnitTypeInBridge } from '@modules/rx-intuitive-teeth-orchestrator/models/intuitive-indication';
import { UnitTypesInBridge } from '@modules/rx-intuitive-teeth-orchestrator/models';

/**
 * Translates a teeth-diagram indication
 *
 * - If the value is a {@link UnitTypes}  using UnitTypes prefix.
 * - Else if the value is a {@link UnitTypesInBridge} using UnitTypesInBridge prefix.
 * - If neither resolves, returns an empty string.
 *
 * Usage: `{{ indication | indicationTranslate }}` or `{{ indication | indicationTranslate: params }}`
 */
@Pipe({
	name: 'indicationTranslate',
	standalone: true,
	pure: false
})
export class IndicationTranslatePipe extends TranslatePipe implements PipeTransform {
	constructor(translate: TranslateService, ref: ChangeDetectorRef) {
		super(translate, ref);
	}

	override transform(value: IntuitiveIndication | string | number | null | undefined, ...args: any[]): any {
		if (value === undefined || value === null || typeof value === 'string') {
			return '';
		}

		const unitType = toUnitType(value);

		if (unitType != null) {
			return super.transform(`UnitTypes.${UnitTypes[unitType]}`, ...args);
		}

		if (value === (IntuitiveIndication.Bridge as number)) {
			return super.transform('UnitTypes.Bridge', ...args);
		}

		const unitTypeInBridge = toUnitTypeInBridge(value);

		if (unitTypeInBridge != null) {
			return super.transform(`BridgeUnitTypes.${UnitTypesInBridge[unitTypeInBridge]}`, ...args);
		}

		return '';
	}
}
